import axios from 'axios';
import BASEURL from '../utils/config';
import { history } from '../utils/history';

const authUrl = () => {
  let token = '';
  try {
    token = JSON.parse(localStorage.getItem('token'));
  } catch (e) {
    localStorage.clear();
    history.push('/login');
  }

  if (token && token.id) {
    return token.id;
  }
  return '';
};

export const axiosApi = axios.create({
  baseURL: BASEURL,
});

axiosApi.interceptors.request.use((config) => {
  if (config.headers) config.headers.Authorization = `Bearer ${authUrl()}`;

  return config;
});
